<ul>
    <li *ngFor="let trv of model" >
        <span class="im gireh" (click)="expand(trv)">{{trv.cnf.exp==1 ? '' : '' }}</span>
        <span style="visibility: hidden">ا</span>
        <span class="im fold"> </span>
        <span class="title">{{trv.tit}}</span>
        <app-treevi *ngIf="trv.cnf.exp==1" class="treev" [model]="trv.trvis"></app-treevi>
    </li>
</ul>